/* eslint-disable import/first */
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from '@reach/router';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
import { generateProductRoute } from 'spwa-ui-library/esm/utils/path';
const { useSelector, useDispatch } = Redux;
import { FormattedMessage, useIntl } from 'react-intl';
const { selectFirstMenu } = Slices.menuSlice;
const { selectDesktop } = Slices.appSlice;
const { getClusterId } = Slices.configSlice;
const { selectProductEntities, fetchProductsByCategoryId } = Slices.productSlice;
const { selectDefaultAddress } = Slices.addressSlice;
import Loader from '../../components/Loader';
const { addProductToPrevCustomization, addProductToCustomize } = Slices.tempCartSlice;
const { addWithoutCalculation, updateWithIndex } = Slices.cartSlice;
const { selectCurrentCountry } = Slices.profileSlice;
const { selectCountryValidations } = Slices.configSlice;
import Header from '../../components/Header';
import LanguageButton from '../../components/LanguageButton';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { AiOutlineLeft } from '@react-icons/all-files/ai/AiOutlineLeft';
import { AiOutlineRight } from '@react-icons/all-files/ai/AiOutlineRight';
import {
  trackingAddedToCartGA,
  addToCartGA,
  trackingProductDetailGA,
  trackingProductViewGA,
} from 'spwa-ui-library/esm/utils/helperGA';
import {
  getAdditionalPrice,
  getRemovedItems,
  getVariantDetails,
  getAddedItems,
  getSelectedItem,
} from 'spwa-ui-library/esm/utils/helper';
import SeoTitle from './../../components/SeoTitle/index';
import css from './index.module.scss';
import DealsStepper from './DealsStepper';
import ProductsContainer from './ProductsContainer';
import BundleGroupDialog from '../../components/ProductTileList/BundleGroupDialog';
import BogoFreePizzaUnlocked from './BogoFreePizzaUnlocked';
import classNames from 'classnames';
const { selectCategoryEntities } = Slices.categorySlice;
const { getProductInfo } = Slices.productSlice;
const { setBundleCustomisedData } = Slices.tempCartSlice;
function Deal({
  onAddToCart,
  locale,
  encodedCategoryName,
  categoryID,
  encodedProductName,
  productID,
}) {
  const dispatch = useDispatch();
  const intl = useIntl();
  const navigateHook = useNavigate();
  const location = useLocation();
  const storageId = localStorage.getItem('unlockedStepperId');
  const [unlockedStepperId, setUnlockedStepperId] = useState(storageId);
  const { retUrl } = location.state || { retUrl: window.location.href };
  const isDesktop = useSelector(selectDesktop);
  // console.log(retUrl, 'REDTT');
  const productsMap = useSelector(selectProductEntities);
  const [showBundleGroupDialog, setShowBundleGroupDialog] = useState(0);
  const [updateBundleGroupDialog, setUpdateBundleGroupDialog] = useState(0);
  const [enableBogoPopup, setEnableBogoPopup] = useState(false);

  const locationSearch = new URLSearchParams(location.search);
  const country = useSelector(selectCurrentCountry).toString().toLowerCase();
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  let mainProductObj = productsMap[productID];
  let productObj = productsMap[productID];
  const currency = countryValidations?.currency;
  const bogoProducts = useSelector((state) => state.product.bogoProdList);

  if (locationSearch.has('option')) {
    let selectedProductItem =
      productObj?.items?.find((item) => {
        let itemInfo;
        if (!item?.id) {
          itemInfo = productsMap[item];
        } else {
          itemInfo = item;
        }
        return (
          itemInfo['sel1Value'] == locationSearch.get('option') ||
          itemInfo['id'] == locationSearch.get('option')
        );
      }) || productObj;

    productObj = productsMap[selectedProductItem?.id || selectedProductItem] || selectedProductItem;
  }

  const customizeItem = useSelector((state) => state.tempCart);
  const cart = useSelector((state) => state.cart);
  const categoryList = useSelector((state) => state.category);
  const address = useSelector(selectDefaultAddress);
  const menu = useSelector(selectFirstMenu);
  const categories = useSelector(selectCategoryEntities);
  const [errorAddCart, setErrorAddCart] = useState('');
  const [errorStatus, setErrorStatus] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);
  const bogoLocalState =
    window.localStorage.getItem('notShowBogoPopup') || localStorage.getItem('notShowBogoPopup');
  let mainProduct = [];
  mainProduct[0] = Object.assign({}, productObj);
  const clusterId = useSelector(getClusterId);
  const productCustomization = customizeItem?.data?.items?.find(({ id }) => id == productID);

  useEffect(() => {
    const availableStepCount = productObj?.steps?.reduce(
      (acc, curr) => (curr?.isHidden == 0 && curr?.isAddon == 0 ? acc + 1 : acc),
      0
    );

    let productCount = 0;
    for (let _ of Object.values(productCustomization?.bundle || {})) {
      productCount += 1;
    }
    if (productCount >= availableStepCount && !enableBogoPopup && bogoLocalState != 'true') {
      setEnableBogoPopup(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bogoLocalState, enableBogoPopup, productCustomization, productObj?.steps]);

  useEffect(() => {
    let productInfo = productsMap[productID];
    if (productInfo?.bundleTypeId == 'bundle_group' && !window.location.href.includes('option')) {
      setUpdateBundleGroupDialog(productID);
    }
  }, [productID, productsMap]);

  function generateBundleItemsData(productCustomization, productObj) {
    const generatedData = {
      productName: productObj?.name,
      productDescription: productObj?.description,
      productId: productObj?.id,
      items: [],
    };

    let customizationItem = productCustomization['bundle'];
    if (productsMap[productObj?.id]?.typeId == 'simple') {
      customizationItem = productCustomization['items'] || productCustomization['bundle'];
    }

    if (Object.keys(productObj || {}).length && Object.entries(customizationItem || {}).length) {
      const steps = productObj?.steps;

      steps.forEach((step, stepIndex) => {
        if (!step?.isHidden) {
          const stepProducts = Object.keys(customizationItem || {});

          if (step && step.options) {
            step.options
              .filter(
                (option) =>
                  stepProducts.includes(option.id) || stepProducts.includes(option.id.toString())
              )
              .forEach((product) => {
                const isDefault = customizationItem[step.id][product.id]?.isDefault;
                let selectedProductItem =
                  product?.typeId === 'configurable'
                    ? getSelectedItem(customizationItem[step.id][product.id], product)
                    : null;
                let variantsInfo = getVariantDetails(
                  customizationItem[step.id][product.id],
                  product
                );
                let addedProductItems = getAddedItems(
                  customizationItem[step.id][product.id],
                  selectedProductItem
                );
                let removedProductItems = getRemovedItems(
                  customizationItem[step.id][product.id],
                  selectedProductItem,
                  isDefault
                );
                let additionPrice = getAdditionalPrice(
                  customizationItem[step.id][product.id],
                  selectedProductItem
                );
                const itemTitle = `${product?.title}`;

                generatedData.items.push({
                  itemTitle,
                  addedProductItems,
                  removedProductItems,
                  additionPrice,
                  variantsInfo,
                });
              });
          }
        }
      });
    }

    return generatedData;
  }

  const tempItems = customizeItem?.data?.items?.find(({ id }) => id == productID);
  const tempItemBundle = (tempItems?.items ? tempItems.items : tempItems?.bundle) || {};

  let availableSteps = productObj?.steps?.filter((step) => !step?.isHidden);

  const [currentStepperId, setCurrentStepperId] = useState(
    parseInt(Math.min(unlockedStepperId || availableSteps?.[0]?.id, availableSteps?.[0]?.id))
  );

  useEffect(() => {
    let availableStepKeys = (availableSteps || []).map((a) => a?.id?.toString() || a?.id) || [];

    let isCurrentStepAvailable = availableStepKeys?.includes(
      currentStepperId?.toString() || currentStepperId
    );

    if (
      availableSteps?.length > 0 &&
      (!currentStepperId ||
        !isCurrentStepAvailable ||
        window.localStorage.getItem('backButtonPressed'))
    ) {
      let tempCartItem = customizeItem?.data?.items?.find(({ id }) => id == productID);
      let itemKeys = Object.keys(tempCartItem?.items || tempCartItem?.bundle || {});

      let key;
      for (let i = 0; i < itemKeys.length; i++) {
        if (availableStepKeys.includes(itemKeys[i])) {
          key = itemKeys[i];
        }
      }

      let idx;
      if (!key) {
        idx = 0;
      } else {
        idx = availableStepKeys?.indexOf(key) || 0;
        idx += 1;
        if (idx < 0) {
          idx = 0;
        }
      }

      if (availableSteps.length == 1) {
        idx = 0;
      }

      if (availableSteps?.[idx]?.id) {
        console.log(`8 setting - `, availableSteps?.[idx]?.id);
        window.localStorage.removeItem('backButtonPressed');
        setCurrentStepperId(availableSteps?.[idx]?.id);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [availableSteps, currentStepperId]);

  useEffect(() => {
    const avlSteps = productObj?.steps?.filter((step) => !step?.isHidden);
    console.log(`hereeee`);
    if (!avlSteps?.[0]?.options?.[0]?.id && !productObj?.isHiddenDeal) {
      dispatch(
        fetchProductsByCategoryId({
          id: productsMap[productID]?.categories?.[0] || categoryID,
          cluster: clusterId,
          Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
        })
      ).then((catData) => {
        dispatch(
          getProductInfo({
            id: productID,
            cluster: clusterId,
            service: address?.addressSubType || 'DELIVERY',
            categoryId: productsMap[productID]?.categories?.[0] || categoryID,
            Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
          })
        ).then((resp) => {
          if (!resp?.payload || Object.values(resp?.payload || {}).length < 2) {
            navigateHook(`/${intl.locale}/home`);
          }
          if (resp?.payload?.bundleTypeId == 'bundle_group') {
            // find correct item WRT option
            let itemId;
            for (let item of resp?.payload?.items || []) {
              if (
                (item?.id == locationSearch.get('option') ||
                  item?.sel1Value == locationSearch.get('option')) &&
                !item?.steps?.length
              ) {
                itemId = item?.id;
              }
            }

            if (itemId) {
              dispatch(
                getProductInfo({
                  id: itemId,
                  cluster: clusterId,
                  service: address?.addressSubType || 'DELIVERY',
                  categoryId: productsMap[itemId]?.categories?.[0] || categoryID,
                  Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
                })
              );
            }
          }
          let lastRefresh = window.localStorage.getItem('refreshedOn', new Date().getTime()) || '';
          let [prodId = 0, lastRefreshOn = 0] = lastRefresh.split('-');

          let timeDifference = new Date().getTime() - parseFloat(lastRefreshOn);

          if (!lastRefreshOn && timeDifference >= 10000) {
            dispatch(
              addProductToCustomize({
                productType: resp?.payload?.bundleTypeId,
                updatedOn: new Date().getTime(),
                mainProductId: resp?.payload?.id,
                data: {
                  ...resp.payload,
                  category: categoryID == 999 ? resp?.payload?.categories?.[0] : categoryID,
                  noIncrement: true,
                },
              })
            );
            setTimeout(() => {
              window.localStorage.setItem(
                'refreshedOn',
                `${resp.payload.id}-${new Date().getTime()}`
              );
              window.location.reload();
            }, 1000);
          }
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, productID, clusterId, address, categoryID, intl]);

  useEffect(() => {
    let completedStep = window.localStorage.getItem('completedStep');

    if (completedStep) {
      let availableSteps;
      if (productObj?.isBOGO && Array.isArray(productObj?.items)) {
        const optionId = parseInt(locationSearch.get('option'));
        availableSteps = productObj?.items
          ?.find((item) => item?.id == optionId)
          ?.steps?.filter((step) => !step?.isHidden);
      } else {
        availableSteps = productObj?.steps?.filter((step) => !step?.isHidden);
      }

      let stepIndex = availableSteps?.findIndex((step) => step?.id == completedStep);

      if (stepIndex > currentStepperId) {
        stepIndex = availableSteps?.findIndex((step) => step?.id == currentStepperId);
      }

      // validate if completed step exists in the available step or not.
      let availableStepIds = availableSteps?.map((a) => a?.id) || [];
      if (productObj?.isBOGO && !availableStepIds?.includes(completedStep)) {
        completedStep = availableSteps?.[0]?.id || completedStep;
      }

      let newStepUnlockedId, newStepId;

      const completedStepInfo = availableSteps?.find((avlblStep) => avlblStep.id == completedStep);
      const completedStepIndex = availableSteps?.findIndex(
        (avlblStep) => avlblStep.id == completedStep
      );

      if (stepIndex == availableSteps?.length - 1) {
        newStepUnlockedId = availableSteps[stepIndex]?.id;
        newStepId = completedStep;
      } else {
        newStepUnlockedId = availableSteps[completedStepIndex + 1]?.id;
        newStepId = availableSteps[completedStepIndex + 1]?.id;
      }

      const minimumOptionsRequired = Math.min(
        completedStepInfo?.minimum || 1,
        completedStepInfo?.options?.length || 1
      );

      const completedStepCount = Object.keys(
        productCustomization?.['bundle']?.[completedStep] || {}
      )?.length;

      window.localStorage.removeItem('completedStep');
      if (
        completedStepCount >= minimumOptionsRequired &&
        newStepUnlockedId &&
        newStepUnlockedId > parseInt(window.localStorage.getItem(`unlockedStepperId`))
      ) {
        setUnlockedStepperId(parseInt(newStepUnlockedId));
        console.log(`9 setting unlockedStepperId - `, newStepUnlockedId);
        window.localStorage.setItem(`unlockedStepperId`, parseInt(newStepUnlockedId));
      } else {
        const previousUnlockedStepperId = parseInt(
          window.localStorage.getItem(`unlockedStepperId`)
        );
        console.log(`9.1 setting unlockedStepperId - `, previousUnlockedStepperId);
        window.localStorage.setItem(`unlockedStepperId`, previousUnlockedStepperId);
      }

      console.log(`10 setting - `, newStepId);
      setCurrentStepperId((prev) => parseInt(newStepId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationSearch, productCustomization]);

  const handleBundleGroupAction = (optionId) => {
    setShowBundleGroupDialog(0);
    setPageLoader(true);
    setUpdateBundleGroupDialog(0);
    const bundleId = showBundleGroupDialog || updateBundleGroupDialog;
    const category = categoryList.entities[productsMap[bundleId]?.['categories']?.[0]];
    let productRoute = generateProductRoute({
      product: productsMap[bundleId],
      category,
      locale: intl.locale.toLowerCase(),
    });

    productRoute = `${productRoute}/bundle?bundleGroup=1&option=${optionId}`;

    if (locationSearch.has('cartId')) {
      productRoute = `${productRoute}&cartId=${locationSearch.get('cartId')}`;
    }

    if (productsMap[bundleId]?.isHiddenDeal) {
      navigateHook(productRoute, {
        state: {
          retUrl: window.location.pathname,
        },
        replace: true,
      });
      console.log(`dispatch 22`);
      dispatch(
        addProductToCustomize({
          productType: 'bundle',
          updatedOn: new Date().getTime(),
          mainProductId: productsMap[bundleId],
          data: {
            ...productsMap[optionId],
            id: bundleId,
            category: productsMap[bundleId]?.categories[0],
            noIncrement: true,
          },
        })
      );
    } else {
      dispatch(
        getProductInfo({
          id: bundleId,
          cluster: clusterId,
          service: address?.addressSubType || 'DELIVERY',
          categoryId: productsMap[bundleId]?.categories?.[0] || category?.id,
          Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
        })
      ).then((resp) => {
        setShowBundleGroupDialog(0);
        setPageLoader(true);
        setUpdateBundleGroupDialog(0);

        let selectedProductItem = resp.payload?.items?.find((item) => {
          let itemInfo;
          if (!item?.id) {
            itemInfo = productsMap[item];
          } else {
            itemInfo = item;
          }
          return itemInfo['sel1Value'] == optionId;
        });
        if (!selectedProductItem?.id) {
          selectedProductItem = productsMap[selectedProductItem];
        }

        dispatch(
          getProductInfo({
            id: selectedProductItem?.id,
            cluster: clusterId,
            service: address?.addressSubType || 'DELIVERY',
            categoryId: productsMap[selectedProductItem?.id]?.categories?.[0] || category?.id,
            Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
          })
        ).then((resp) => {
          navigateHook(productRoute, {
            state: {
              retUrl: window.location.pathname,
            },
            replace: true,
          });
          console.log(`dispatch 33`);
          dispatch(
            addProductToCustomize({
              productType: 'bundle',
              updatedOn: new Date().getTime(),
              mainProductId: productsMap[bundleId],
              data: {
                ...(Object.keys(productsMap[optionId] || {}).length > 0
                  ? productsMap[optionId]
                  : resp.payload),
                id: bundleId,
                category: productsMap[bundleId]?.categories[0],
                noIncrement: true,
                selectedBundleId: selectedProductItem?.id,
              },
            })
          );
        });
      });
    }
    setShowBundleGroupDialog(0);
    setUpdateBundleGroupDialog(0);
  };

  const addCart = () => {
    // TODO: Fix this condition to enable bogo popup in cart update scenario
    if (productObj?.isBOGO && !enableBogoPopup) {
      setEnableBogoPopup(true);
      return;
    }

    setPageLoader((prev) => true);

    let payload = customizeItem.data?.items?.find(({ id }) => id == productID);
    payload = JSON.parse(JSON.stringify(payload || {}));

    if (productObj?.typeId == 'simple' && productObj?.bundleTypeId?.includes('bundle')) {
      let isDefaultPayload = true;
      for (let [stepId, stepInfo] of Object.entries(payload['bundle'] || payload['items'] || {})) {
        let productStepInfo = productObj?.steps?.find((s) => s.id == stepId);
        for (let [prodId, prodPayloadObj] of Object.entries(stepInfo)) {
          let prodObject = productStepInfo?.options?.find((p) => p.id == prodId);
          if (!(prodObject?.default == 1 || prodObject?.selected == 1)) {
            isDefaultPayload = false;
            break;
          }
        }
      }
      if (isDefaultPayload) {
        payload['isDefault'] = true;
        delete payload['isCustomized'];
      } else {
        payload['isDefault'] = false;
        payload['isCustomized'] = true;
      }
    }
    if (payload.subList) {
      delete payload['subList'];
    }
    if (payload.editDesc) {
      delete payload['editDesc'];
    }

    // if (payload?.qty > 1) {
    //   payload[`price`] = parseFloat(payload[`price`] || 0) / (payload?.qty || 1);
    // }
    let tempCustomizePayload = JSON.parse(JSON.stringify(payload || {}));
    delete tempCustomizePayload['notAdded'];

    // delete notAdded:true ones
    if (tempCustomizePayload['items'] || tempCustomizePayload['bundle']) {
      let payloadBundle = JSON.parse(
        JSON.stringify(tempCustomizePayload?.items || tempCustomizePayload?.bundle || {})
      );
      for (let [payloadStep, payloadStepInfo] of Object.entries(payloadBundle || {})) {
        for (let [payloadStepProduct, payloadStepProductInfo] of Object.entries(
          payloadStepInfo || {}
        )) {
          if (payloadStepProductInfo?.notAdded) {
            delete payloadBundle[payloadStep][payloadStepProduct];
          }
        }
      }
      if (tempCustomizePayload['items']) {
        tempCustomizePayload['items'] = payloadBundle;
      } else {
        tempCustomizePayload['bundle'] = payloadBundle;
      }
    }

    if (locationSearch.has('cartId')) {
      let bundleId;
      if (
        productsMap[payload?.id]?.bundleTypeId?.includes('bundle_group') &&
        !productsMap[payload?.id]?.isBOGO
      ) {
        payload = JSON.parse(JSON.stringify(payload || {}));
        payload['id'] = productObj?.id;
        delete payload['errMsg'];
        delete payload['editDesc'];
      } else if (productsMap[payload?.id]?.isBOGO) {
        const subItems = [];
        let productCategory = parseInt(Object.keys(payload?.bundle || {})[0]);
        const categoryId = (productCategory - (productCategory % 10)) / 10;
        bundleId = categoryId;
        const productItems = Object.values(payload?.bundle || {});
        const stepIds = Object.keys(payload?.bundle || {});

        const outerProduct = productsMap[payload?.id]?.items?.find((itm) => itm.id == categoryId);
        let idx = 0;

        for (let items of productItems) {
          let item = JSON.parse(JSON.stringify(items));
          for (let [itemsId, itemsInfo] of Object.entries(item)) {
            if (itemsInfo?.notAdded) {
              delete item[itemsId];
            }
          }

          const stepId = stepIds[idx];
          const itemId = Object.keys(item || {})[0];
          const itemInfo = Object.values(item || {})[0];

          let productOptionObj = outerProduct?.steps?.[idx]?.options?.find(
            (optn) => optn?.id == itemId
          );

          let variantArray = [-1, -1, -1];
          Object.values(itemInfo?.variants || {}).forEach((variant, index) => {
            variantArray[index] = variant;
          });

          let productItemObj = productOptionObj?.items?.find((item) => {
            let isVariantSame = true;
            variantArray.forEach((variant, index) => {
              if (item[`sel${index + 1}Value`] != variant) {
                isVariantSame = false;
              }
            });
            return isVariantSame;
          });

          let itemBasePrice =
            productItemObj?.price >= 0
              ? productItemObj?.price
              : productItemObj?.specialPrice || productItemObj?.originalPrice || 0;

          subItems.push({
            ...itemInfo,
            basePrice: itemBasePrice,
            id: itemId,
            typeId: 'configurable',
            catId: categoryId,
            isDefault: itemInfo?.items ? false : true,
            stepId: stepId,
          });

          idx += 1;
        }

        if (subItems[0]?.basePrice == subItems[1]?.basePrice) {
          subItems.sort((item1, item2) => item2.price - item1.price);
        } else {
          subItems.sort((item1, item2) => item2.basePrice - item1.basePrice);
        }

        subItems.length = 2;

        subItems[subItems.length - 1].price =
          subItems[subItems.length - 1].price - subItems[subItems.length - 1].basePrice || 0;

        payload = JSON.parse(JSON.stringify(payload || {}));

        let selectedBundleId = bundleId || productObj['id'];
        let bundle = payload['bundle'];
        delete payload['bundle'];
        payload['subItem'] = subItems;
        payload['catId'] = payload['id'];
        delete payload['id'];
        delete payload['typeId'];
        if (!payload?.additionalInfo) {
          payload['additionalInfo'] = {};
        }
        payload['additionalInfo']['selectedBundleId'] = selectedBundleId;
        payload['additionalInfo']['catId'] = productObj?.categories?.[0] || categoryID;
        payload['additionalInfo']['bundle'] = bundle;
      }

      if (productsMap[productID]?.typeId == 'bundle_group') {
        payload = JSON.parse(JSON.stringify(payload || {}));
        payload[`parentId`] = productID;
      }

      if (productObj?.typeId == 'simple' && productObj?.bundleTypeId?.includes('bundle')) {
        let isDefaultPayload = true;
        for (let [stepId, stepInfo] of Object.entries(
          payload['bundle'] || payload['items'] || {}
        )) {
          let productStepInfo = productObj?.steps?.find((s) => s.id == stepId);
          for (let [prodId, prodPayloadObj] of Object.entries(stepInfo)) {
            let prodObject = productStepInfo?.options?.find((p) => p.id == prodId);
            if (!(prodObject?.default == 1 || prodObject?.selected == 1)) {
              isDefaultPayload = false;
              break;
            }
          }
        }
        if (isDefaultPayload) {
          payload['isDefault'] = true;
        } else {
          payload['isDefault'] = false;
        }
      }

      payload = JSON.parse(JSON.stringify(payload));
      // delete notAdded:true ones
      if (payload['items'] || payload['bundle']) {
        let payloadBundle = JSON.parse(JSON.stringify(payload?.items || payload?.bundle || {}));
        for (let [payloadStep, payloadStepInfo] of Object.entries(payloadBundle || {})) {
          for (let [payloadStepProduct, payloadStepProductInfo] of Object.entries(
            payloadStepInfo || {}
          )) {
            if (payloadStepProductInfo?.notAdded) {
              delete payloadBundle[payloadStep][payloadStepProduct];
            }
          }
        }
        if (payload['items']) {
          payload['items'] = payloadBundle;
        } else {
          payload['bundle'] = payloadBundle;
        }
      }

      let cartItem = cart.data.items[locationSearch.get('cartId')];

      if (payload['qty'] != cartItem['qty']) {
        payload['qty'] = cartItem['qty'];
        payload['price'] = (payload['price'] || 0) * (cartItem['qty'] || 1);
      }

      dispatch(updateWithIndex({ index: locationSearch.get('cartId'), productPayload: payload }));
      dispatch(
        addProductToPrevCustomization({
          id: tempCustomizePayload?.additionalInfo?.bundleGroupId || tempCustomizePayload?.id,
          data: {
            ...tempCustomizePayload,
            id: tempCustomizePayload?.additionalInfo?.bundleGroupId || tempCustomizePayload?.id,
          },
        })
      );
    } else {
      payload = JSON.parse(JSON.stringify(payload || {}));
      if (payload?.additionalInfo?.selectedBundleId) {
        payload['additionalInfo']['bundleGroupId'] = payload.id;
      }

      let bundleId;

      if (productObj?.typeId == 'simple' && productObj?.bundleTypeId?.includes('bundle')) {
        let isDefaultPayload = true;
        for (let [stepId, stepInfo] of Object.entries(
          payload['bundle'] || payload['items'] || {}
        )) {
          let productStepInfo = productObj?.steps?.find((s) => s.id == stepId);

          for (let [prodId, prodPayloadObj] of Object.entries(stepInfo)) {
            let prodObject = productStepInfo?.options?.find((p) => p.id == prodId);
            if (!(prodObject?.default == 1 || prodObject?.selected == 1)) {
              isDefaultPayload = false;
              break;
            }
          }
        }
        if (isDefaultPayload) {
          payload['isDefault'] = true;
        }
        payload['typeId'] = 'simple';
        payload['items'] = payload['bundle'];
        delete payload['bundle'];
      }

      if (productObj?.isBOGO) {
        payload = JSON.parse(JSON.stringify(payload || {}));
        // set subItems instead of bundle with price information
        const subItems = [];
        let productCategory = parseInt(Object.keys(payload?.bundle || {})[0]);
        const categoryId = (productCategory - (productCategory % 10)) / 10;
        bundleId = categoryId;
        const productItems = Object.values(payload?.bundle || {});
        const stepIds = Object.keys(payload?.bundle || {});

        const outerProduct = productsMap[payload?.id]?.items?.find((itm) => itm.id == categoryId);
        let idx = 0;

        for (let items of productItems) {
          let item = JSON.parse(JSON.stringify(items));
          for (let [itemsId, itemsInfo] of Object.entries(item)) {
            if (itemsInfo?.notAdded) {
              delete item[itemsId];
            }
          }

          const stepId = stepIds[idx];
          const itemId = Object.keys(item || {})[0];
          const itemInfo = Object.values(item || {})[0];

          let productOptionObj = outerProduct?.steps?.[idx]?.options?.find(
            (optn) => optn?.id == itemId
          );

          let variantArray = [-1, -1, -1];
          Object.values(itemInfo?.variants || {}).forEach((variant, index) => {
            variantArray[index] = variant;
          });

          let productItemObj = productOptionObj?.items?.find((item) => {
            let isVariantSame = true;
            variantArray.forEach((variant, index) => {
              if (item[`sel${index + 1}Value`] != variant) {
                isVariantSame = false;
              }
            });
            return isVariantSame;
          });

          let itemBasePrice =
            productItemObj?.price >= 0
              ? productItemObj?.price
              : productItemObj?.specialPrice || productItemObj?.originalPrice || 0;

          subItems.push({
            ...itemInfo,
            basePrice: itemBasePrice,
            id: itemId,
            typeId: 'configurable',
            catId: categoryId,
            isDefault: itemInfo?.items ? false : true,
            stepId: stepId,
          });

          idx += 1;
        }

        if (subItems[0]?.basePrice == subItems[1]?.basePrice) {
          subItems.sort((item1, item2) => item2.price - item1.price);
        } else {
          subItems.sort((item1, item2) => item2.basePrice - item1.basePrice);
        }

        subItems[subItems.length - 1].price = 0;

        let selectedBundleId = bundleId || productObj['id'];
        let bundle = payload['bundle'];
        delete payload['bundle'];
        delete payload['subItem'];
        payload['subItem'] = JSON.parse(JSON.stringify(subItems || []));
        payload['catId'] = payload['id'];
        delete payload['id'];
        delete payload['typeId'];
        if (!payload?.additionalInfo) {
          payload['additionalInfo'] = {};
        }
        payload['additionalInfo']['selectedBundleId'] = selectedBundleId;
        payload['additionalInfo']['catId'] = productObj?.categories?.[0] || categoryID;
        payload['additionalInfo']['bundle'] = bundle;
      }

      // sanitize for empty objects
      if (payload?.bundle) {
        for (let step of Object.keys(payload?.bundle || {})) {
          if (payload.bundle[step] && Object.keys(payload.bundle[step] || {}).length == 0) {
            delete payload.bundle[step];
          }
        }
      }

      payload = JSON.parse(JSON.stringify(payload));
      // delete notAdded:true ones
      if (payload['items'] || payload['bundle']) {
        let payloadBundle = JSON.parse(JSON.stringify(payload?.items || payload?.bundle || {}));
        for (let [payloadStep, payloadStepInfo] of Object.entries(payloadBundle || {})) {
          for (let [payloadStepProduct, payloadStepProductInfo] of Object.entries(
            payloadStepInfo || {}
          )) {
            if (payloadStepProductInfo?.notAdded) {
              delete payloadBundle[payloadStep][payloadStepProduct];
            }
          }
        }
        if (payload['items']) {
          payload['items'] = payloadBundle;
        } else {
          payload['bundle'] = payloadBundle;
        }
      }

      const finalPayloadString = JSON.stringify({
        ...(payload || {}),
        parentId: productID,
        id: payload?.additionalInfo?.selectedBundleId || payload.id,
      });

      dispatch(
        addWithoutCalculation({
          ...payload,
          parentId: productID,
          product: productObj,
          id: payload?.additionalInfo?.selectedBundleId || payload.id,
          stringifiedPayload: finalPayloadString,
        })
      );

      dispatch(
        addProductToPrevCustomization({ id: payload?.id, data: { ...tempCustomizePayload } })
      );
    }

    // Customised generateBundleItemsData
    const generatedData = generateBundleItemsData(productCustomization, productObj);
    if (generatedData) {
      dispatch(setBundleCustomisedData(generatedData));
    }

    if (onAddToCart) {
      onAddToCart();
    }

    setTimeout(() => {
      setPageLoader(false);
      // console.log(`retUrl -- `, retUrl);
      if (retUrl && retUrl !== '') {
        if (locationSearch.has('cartId')) {
          navigateHook(`/${intl.locale}/cart`, { replace: true });
        } else if (retUrl?.includes('home')) {
          navigateHook(retUrl);
        } else if (!isDesktop && retUrl?.includes('search')) {
          navigateHook(retUrl, { replace: true });
        } else {
          let urlParts = retUrl.split('/');
          let productId = urlParts[urlParts.length - 2];
          if (
            Object.keys(bogoProducts || {})
              .map((item) => parseInt(item))
              .includes(parseInt(productId))
          ) {
            navigateHook(`/${encodedCategoryName}/${categoryID}`, { replace: true });
          } else if (locationSearch.has('bundleGroup') && !retUrl?.includes('search')) {
            navigateHook(`/${encodedCategoryName}/${categoryID}`, { replace: true });
          } else {
            navigateHook(retUrl, { replace: true });
          }
        }
      } else {
        if (locationSearch.has('cartId')) {
          navigateHook(`/${intl.locale}/cart`, { replace: true });
        } else {
          navigateHook(`/${encodedCategoryName}/${categoryID}`, { replace: true });
        }
      }
    }, 0);
    const selectedCategory = categories[categoryID];
    addToCartGA(mainProduct[0], currency, mainProduct[0]?.name || '', 'ProductDetailPage');
    trackingAddedToCartGA(mainProduct[0], currency, selectedCategory?.name || '', address);
  };

  useEffect(() => {
    // check if product has been added to tempCart, if not, add the product into tempCart
    if (!productCustomization) {
      if (productObj?.bundleTypeId == 'bundle' || productObj?.typeId == 'bundle') {
        dispatch(
          getProductInfo({
            id: productObj.id,
            cluster: clusterId,
            service: address?.addressSubType || 'DELIVERY',
            categoryId: productObj.categories[0],
            Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
          })
        ).then((resp) => {
          console.log(`dispatch 44`);

          dispatch(
            addProductToCustomize({
              productType: productObj.bundleTypeId,
              updatedOn: new Date().getTime(),
              mainProductId: productObj.id,
              data: {
                ...productsMap[productID],
                category: productsMap[productID].categories[0],
                noIncrement: true,
              },
            })
          );
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    address.addressSubType,
    clusterId,
    dispatch,
    intl.locale,
    productCustomization,
    productID,
    productObj?.bundleTypeId,
    productObj?.categories,
    productObj?.id,
    productObj?.typeId,
    productsMap,
  ]);

  useEffect(
    () => {
      trackingProductDetailGA(mainProduct[0], encodedCategoryName);
      trackingProductViewGA(mainProduct[0], currency, encodedCategoryName);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  let isAddToCartEnabled = false;
  let isSkipProceedEnabled = false;

  const availableStepCount = productObj?.steps?.reduce(
    (acc, curr) => (curr?.isHidden == 0 && curr?.isAddon == 0 ? acc + 1 : acc),
    0
  );

  if (productCustomization) {
    const completedStepCount = Object.keys(
      productCustomization?.bundle || productCustomization?.items || {}
    ).length;
    let areAllStepsComplete = true;
    if (availableStepCount <= completedStepCount) {
      // check if all required items per step have been added.
      for (let step of productObj?.steps.filter((step) => !step?.isHidden && !step?.isAddon)) {
        if (
          Math.min(step.minimum, step?.options?.length || 1) >
          (Object.values(
            productCustomization?.bundle?.[step.id] || productCustomization?.items?.[step.id] || {}
          ).reduce((totalQty, product) => {
            return totalQty + (product?.notAdded ? 0 : product?.qty || 1);
          }, 0) || 0)
        ) {
          areAllStepsComplete = false;
        }
      }
    } else {
      areAllStepsComplete = false;
    }
    isAddToCartEnabled = areAllStepsComplete;
    isSkipProceedEnabled = areAllStepsComplete;
  }

  if ((!availableSteps || availableSteps?.length == 0) && updateBundleGroupDialog > 0) {
    return (
      <BundleGroupDialog
        backHandler={true}
        setShowBundleGroupDialog={setUpdateBundleGroupDialog}
        showBundleGroupDialog={updateBundleGroupDialog}
        handleBundleGroupAction={handleBundleGroupAction}
      />
    );
  }

  if (!availableSteps) return null;

  return !productObj ? null : (
    <>
      <SeoTitle
        id="product"
        productname={productObj.name}
        submenuname={categories[categoryID]?.name || categories[productObj.catId]?.name}
        overRideMeta={productObj}
      />
      <Snackbar
        open={errorStatus}
        autoHideDuration={6000}
        onClose={() => setErrorStatus(false)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Alert onClose={() => setErrorStatus(false)} severity="error" sx={{ width: '100%' }}>
          {errorAddCart}
        </Alert>
      </Snackbar>
      <div className={css.root}>
        {pageLoader && <Loader />}
        {isDesktop && <Header title={productObj?.name} actionButtons={[<LanguageButton />]} />}

        {/* SHOW TABS FOR STEPS */}
        {availableSteps && (
          <DealsStepper
            steps={productObj?.steps}
            title={productObj?.isBOGO ? mainProductObj?.name : productObj?.name}
            description={productObj?.description}
            mainProductId={productID}
            price={productObj?.specialPrice || productObj?.originalPrice}
            oldLocation={`/${intl.locale}/${encodedCategoryName}/${categoryID}/bundle`}
            currentStepperId={currentStepperId}
            setCurrentStepperId={setCurrentStepperId}
            setShowBundleGroupDialog={setShowBundleGroupDialog}
          />
        )}
        {!isDesktop &&
          productObj?.steps?.find((step) => step.id === currentStepperId)?.isAddon == 1 && (
            <div
              className={classNames(css.skipBtnMobile, { [css.disabled]: !isSkipProceedEnabled })}
              onClick={() => {
                if (isSkipProceedEnabled) {
                  addCart();
                }
              }}
            >
              <span>
                <FormattedMessage id={'skip_and_proceed_wo_arrow'} />
              </span>
              <span>{intl.locale == 'en' ? <AiOutlineRight /> : <AiOutlineLeft />}</span>
            </div>
          )}

        <ProductsContainer
          currentStepperId={currentStepperId}
          addtoCart={addCart}
          isBundleItem={true}
          stepId={currentStepperId}
          title={productObj?.name}
          mainProductId={productID}
          category={categories[categoryID]}
          setCurrentStepperId={setCurrentStepperId}
          currentStep={productObj?.steps?.find((step) => step.id === currentStepperId)}
          isAddToCartEnabled={isAddToCartEnabled}
          availableStepCount={availableStepCount}
          setShowBundleGroupDialog={setShowBundleGroupDialog}
          availableSteps={availableSteps}
          isSkipProceedEnabled={isSkipProceedEnabled}
        />
        {showBundleGroupDialog > 0 && (
          <BundleGroupDialog
            setShowBundleGroupDialog={setShowBundleGroupDialog}
            showBundleGroupDialog={showBundleGroupDialog}
            handleBundleGroupAction={handleBundleGroupAction}
          />
        )}
        {productObj?.isBOGO &&
          // !bogoLocalState &&
          enableBogoPopup &&
          isAddToCartEnabled &&
          locationSearch.has('bundleGroup') &&
          productCustomization?.additionalInfo?.addedProducts >= availableSteps.length && (
            <BogoFreePizzaUnlocked
              setEnableBogoPopup={setEnableBogoPopup}
              productId={productID}
              isAddToCartEnabled={isAddToCartEnabled}
              addtoCart={addCart}
            />
          )}
      </div>
    </>
  );
}

export default Deal;
